import ControlButton, { ControlButtonProps } from 'pages/Home/admin/ControlButton/ControlButton'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import UploadVideoDialog from '../UploadVideoDialog/UploadVideoDialog'

export interface UploadVideoButtonProps extends ControlButtonProps {
  recordedWebinarId?: string
  videoId?: string
  videoUploadId?: string
}

export default function UploadVideoButton(props: UploadVideoButtonProps) {
  const { recordedWebinarId, videoId, videoUploadId, ...otherProps } = props
  const [t] = useTranslation()
  const [isUploadVideoDialogOpen, setIsUploadVideoDialogOpen] = useState(false)

  return (
    <>
      <ControlButton
        variant="add"
        title={videoUploadId ? t('admin.uploadVideoButton.updateTitle') : t('admin.uploadVideoButton.title')}
        onClick={() => setIsUploadVideoDialogOpen(true)}
        {...otherProps}
      />
      {isUploadVideoDialogOpen && (
        <UploadVideoDialog
          onRequestClose={() => setIsUploadVideoDialogOpen(false)}
          recordedWebinarId={recordedWebinarId}
          videoId={videoId}
          videoUploadId={videoUploadId}
        />
      )}
    </>
  )
}
